import type { SessionStatus } from '@/types/session';
import { env } from '@/lib/env';

const STATUS_CONFIG: Record<
  SessionStatus,
  { label: string; className: string; icon: string }
> = {
  transcribing: {
    label: '文字起こし中',
    className: 'bg-blue-100 text-blue-800',
    icon: '⏳',
  },
  transcribing_failed: {
    label: '文字起こし失敗',
    className: 'bg-red-100 text-red-800',
    icon: '⚠',
  },
  section_config_pending: {
    label: 'セクション設定中',
    className: 'bg-yellow-100 text-yellow-800',
    icon: '✂',
  },
  ai_evaluating: {
    label: env.VITE_SHOW_AI_FEEDBACK ? 'AI評価中' : 'サマリ作成中',
    className: 'bg-purple-100 text-purple-800',
    icon: env.VITE_SHOW_AI_FEEDBACK ? '🧠' : '📝',
  },
  ai_evaluation_failed: {
    label: env.VITE_SHOW_AI_FEEDBACK ? 'AI 評価失敗' : 'サマリ作成失敗',
    className: 'bg-red-100 text-red-800',
    icon: '⚠',
  },
  feedback_pending: {
    label: 'フィードバック中',
    className: 'bg-orange-100 text-orange-800',
    icon: '📝',
  },
  feedback_in_progress: {
    label: 'フィードバック中',
    className: 'bg-orange-100 text-orange-800',
    icon: '📝',
  },
  overall_feedback_pending: {
    label: '全体分析中',
    className: 'bg-amber-100 text-amber-800',
    icon: '📄',
  },
  overall_analysis_approval_pending: {
    label: '全体分析承認待ち',
    className: 'bg-violet-100 text-violet-800',
    icon: '🔍',
  },
  coach_ack_pending: {
    label: 'コーチ確認中',
    className: 'bg-cyan-100 text-cyan-800',
    icon: '👁',
  },
  completed: {
    label: '完了',
    className: 'bg-green-100 text-green-800',
    icon: '✓',
  },
};

export function StatusBadge({
  status,
  labelOverride,
  classNameOverride,
}: {
  status: SessionStatus;
  labelOverride?: string;
  classNameOverride?: string;
}) {
  const { label, className } = STATUS_CONFIG[status];
  return (
    <span className={`inline-flex items-center rounded px-2 py-1 text-xs font-medium ${classNameOverride ?? className}`}>
      {labelOverride ?? label}
    </span>
  );
}
